{
	"title": "Add product to menu",
	"productInformation": "Product information",
	"product": "Product",
	"price": "Sale price",
	"add": "Add product",
	"validateField": "Required field"
}
